import { ADDRESS as AID } from './types/address.js';
import { isObject, digestMessage, isValidSHA256String } from './modules/utils.js';
export const RULES = {
    [AID.state]: [
        {
            value: 'ceska republika',
            reg: /^(cz|cr|czechia|czech|czech republic|cesko)$/,
        },
        {
            value: 'slovenska republika',
            reg: /^(sk|sr|slovakia|slovak|slovak republic|slovensko)$/,
        },
    ],
    [AID.city]: [
        { value: 'hradec kralove', reg: /h\.?\s?kralove$/ },
        { value: 'karlovy vary', reg: /k\.?\s?vary$/ },
        { value: 'm.$1', reg: /(?:m\.?|mor\.|morav.*)\s?(beroun|budejovice|trebova|krumlov)$/ },
        {
            value: '$1 nad labem',
            reg: /(usti|brandys|dvur kralove|roudnice|lysa|kostelec|tynec) (n\.?|nad)\s?(labem|l\.?)/,
        },
        { value: '$1 nad nisou', reg: /(jablonec|hradek|lucany) (n\.?|nad)\s?(nisou|n\.?)/ },
        { value: '$1 nad sazavou', reg: /(zdar|svetla|tynec|ledec|zruc|lipnice) (n\.?|nad)\s?(sazavou|s\.?)/ },
        {
            value: '$1 nad vltavou',
            reg: /(kralupy|tyn|hluboka|libcice|krasna hora|rozmberk) (n\.?|nad)\s?(vltavou|vl\.?|v\.?)/,
        },
        { value: '$1 pod radhostem', reg: /(roznov|frenstat) (p\.?|pod)\s?(radhostem|r\.?)/ },
        { value: '$1 nad ohri', reg: /(klasterec|kynsperk|bohusovice|budyne) (n\.?|nad)\s?(ohri|o\.?)/ },
        { value: '$1 nad orlici', reg: /(usti|tyniste|kostelec|jablonne|brandys) (n\.?|nad)\s?(orlici|o\.?)/ },
        { value: '$1 nad metuji', reg: /(nove mesto|police|teplice) (n\.?|nad)\s?(metuji|m\.?)/ },
        { value: '$1 nad jizerou', reg: /(benatky|bakov|rokytnice|jablonec|vysoke) (n\.?|nad)\s?(jizerou|j\.?)/ },
        { value: '$1 nad luznici', reg: /(veseli|plana|suchdol|lomnice) (n\.?|nad)\s?(luznici|l\.?)/ },
        { value: 'rychnov nad kneznou', reg: /rychnov (n\.?|nad)\s?(kneznou|k\.?)/ },
        { value: 'veseli nad moravou', reg: /veseli (n\.?|nad)\s?(moravou|m\.?)/ },
        { value: 'nove mesto na morave', reg: /nove mesto (n\.?|na)\s?(morave|m\.?)/ },
        { value: 'frydlant nad ostravici', reg: /frydlant (n\.?|nad)\s?(ostravici|o\.?)/ },
        { value: 'bystrice pod hostynem', reg: /bystrice (p\.?|pod)\s?(hostynem|h\.?)/ },
        { value: 'lipnik nad becvou', reg: /lipnik (n\.?|nad)\s?(becvou|b\.?)/ },
        { value: 'bystrice nad pernstejnem', reg: /bystrice (n\.?|nad)\s?(pernstejnem|p\.?)/ },
        { value: 'mnisek pod brdy', reg: /mnisek (p\.?|pod)\s?(brdy|b\.?)/ },
        { value: 'trebechovice pod orebem', reg: /trebechovice (p\.?|pod)\s?(orebem|o\.?)/ },
        { value: 'chlumec nad cidlinou', reg: /chlumec (n\.?|nad)\s?(cidlinou|c\.?)/ },
        { value: 'lomnice nad popelkou', reg: /lomnice (n\.?|nad)\s?(popelkou|p\.?)/ },
        { value: 'hradec nad moravici', reg: /hradec (n\.?|nad)\s?(moravici|m\.?)/ },
        { value: 'bela pod bezdezem', reg: /bela (p\.?|pod)\s?(bezdezem|b\.?)/ },
        { value: 'namest nad oslavou', reg: /namest (n\.?|nad)\s?(oslavou|o\.?)/ },
        { value: 'vrbno pod pradedem', reg: /vrbno (p\.?|pod)\s?(pradedem|p\.?)/ },
        { value: 'rozmital pod tremsinem', reg: /rozmital (p\.?|pod)\s?(tremsinem|t\.?)/ },
        { value: 'jaromerice nad rokytnou', reg: /jaromerice (n\.?|nad)\s?(rokytnou|r\.?)/ },
        { value: 'kostelec nad cernymi lesy', reg: /kostelec (n\.?|nad)\s?(cernymi|c\.?)\s?(lesy|l\.?)/ },
        { value: 'straz pod ralskem', reg: /straz (p\.?|pod)\s?(ralskem|r\.?)/ },
        { value: 'nove mesto pod smrkem', reg: /nove mesto (p\.?|pod)\s?(smrkem|s\.?)/ },
        { value: 'kamenice nad lipou', reg: /kamenice (n\.?|nad)\s?(lipou|l\.?)/ },
        { value: 'benesov nad ploucnici', reg: /benesov (n\.?|nad)\s?(ploucnici|p\.?)/ },
        { value: 'hrusovany nad jevisovkou', reg: /hrusovany (n\.?|nad)\s?(jevisovkou|j\.?)/ },
        { value: 'hodkovice nad mohelkou', reg: /hodkovice (n\.?|nad)\s?(mohelkou|m\.?)/ },
        { value: 'rychnov u jablonce nad nisou', reg: /rychnov u (j\.?|jablonce)\s?(n\.?|nad)\s?(nisou|n\.?)/ },
        { value: 'budisov nad budisovkou', reg: /budisov (n\.?|nad)\s?(budisovkou|b\.?)/ },
        { value: 'janovice nad uhlavou', reg: /janovice (n\.?|nad)\s?(uhlavou|u\.?)/ },
        { value: 'svoboda nad upou', reg: /svoboda (n\.?|nad)\s?(upou|u\.?)/ },
        { value: 'nemcice nad hanou', reg: /nemcice (n\.?|nad)\s?(hanou|h\.?)/ },
        { value: 'ronov nad doubravou', reg: /ronov (n\.?|nad)\s?(doubravou|d\.?)/ },
        { value: 'bela nad radbuzou', reg: /bela (n\.?|nad)\s?(radbuzou|r\.?)/ },
        { value: 'brezova nad svitavou', reg: /brezova (n\.?|nad)\s?(svitavou|s\.?)/ },
        { value: 'becov nad teplou', reg: /becov (n\.?|nad)\s?(teplou|t\.?)/ },
        { value: 'straz nad nezarkou', reg: /straz (n\.?|nad)\s?(nezarkou|n\.?)/ },
        { value: 'praha', reg: /praha.*/ },
        { value: 'praha', reg: /pha(\s.?|\d+)?.*/ },
        { value: 'n.', reg: /\sn(\.?|a|ad)\s/ },
        { value: 'p.', reg: /\sp(\.?|od)\s/ },
        { value: 'c.', reg: /(^cesk[aey]\s|^c\s)/ },
        { value: 'sv.$2', reg: /(svat[aey]|sv\s)(.+)/ },
        { value: '$1m.', reg: /(nove|stare|horni|dolni)\smesto($|(\s|\-).*)/ },
        { value: '', reg: /[\-–,\/\(\s]+(sever|jih|vychod|zapad|mesto|stred)($|\))/ },
    ],
    [AID.street]: [
        { value: '$1|$2', reg: /^([a-z\-\.\' ]*[0-9]{0,}[a-z\-\.\' ]+)([0-9]{1,}.*)?$/ },
        { value: '$1', reg: /^(.*)\|$/ },
    ],
    [AID.houseNumber]: [],
    [AID.postalCode]: [],
};
const CHAR_MAP = {
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    Æ: 'AE',
    Ç: 'C',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    Ð: 'D',
    Ñ: 'N',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    Ý: 'Y',
    ß: 'ss',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    æ: 'ae',
    ç: 'c',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    ð: 'd',
    ñ: 'n',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ü: 'u',
    ý: 'y',
    ÿ: 'y',
    Ā: 'A',
    ā: 'a',
    Ă: 'A',
    ă: 'a',
    Ą: 'A',
    ą: 'a',
    Ć: 'C',
    ć: 'c',
    Ĉ: 'C',
    ĉ: 'c',
    Ċ: 'C',
    ċ: 'c',
    Č: 'C',
    č: 'c',
    Ď: 'D',
    ď: 'd',
    Đ: 'D',
    đ: 'd',
    Ē: 'E',
    ē: 'e',
    Ĕ: 'E',
    ĕ: 'e',
    Ė: 'E',
    ė: 'e',
    Ę: 'E',
    ę: 'e',
    Ě: 'E',
    ě: 'e',
    Ĝ: 'G',
    ĝ: 'g',
    Ğ: 'G',
    ğ: 'g',
    Ġ: 'G',
    ġ: 'g',
    Ģ: 'G',
    ģ: 'g',
    Ĥ: 'H',
    ĥ: 'h',
    Ħ: 'H',
    ħ: 'h',
    Ĩ: 'I',
    ĩ: 'i',
    Ī: 'I',
    ī: 'i',
    Ĭ: 'I',
    ĭ: 'i',
    Į: 'I',
    į: 'i',
    İ: 'I',
    Ĵ: 'J',
    ĵ: 'j',
    Ķ: 'K',
    ķ: 'k',
    ĸ: 'k',
    Ĺ: 'L',
    ĺ: 'l',
    Ļ: 'L',
    ļ: 'l',
    Ľ: 'L',
    ľ: 'l',
    Ń: 'N',
    ń: 'n',
    Ņ: 'N',
    ņ: 'n',
    Ň: 'N',
    ň: 'n',
    ŉ: 'n',
    Ō: 'O',
    ō: 'o',
    Ŏ: 'O',
    ŏ: 'o',
    Ő: 'O',
    ő: 'o',
    Ŕ: 'R',
    ŕ: 'r',
    Ŗ: 'R',
    ŗ: 'r',
    Ř: 'R',
    ř: 'r',
    Ś: 'S',
    ś: 's',
    Ŝ: 'S',
    ŝ: 's',
    Ş: 'S',
    ş: 's',
    Š: 'S',
    š: 's',
    Ţ: 'T',
    ţ: 't',
    Ť: 'T',
    ť: 't',
    Ŧ: 'T',
    ŧ: 't',
    Ũ: 'U',
    ũ: 'u',
    Ū: 'U',
    ū: 'u',
    Ŭ: 'U',
    ŭ: 'u',
    Ů: 'U',
    ů: 'u',
    Ű: 'U',
    ű: 'u',
    Ų: 'U',
    ų: 'u',
    Ŵ: 'W',
    ŵ: 'w',
    Ŷ: 'Y',
    ŷ: 'y',
    Ÿ: 'Y',
    Ź: 'Z',
    ź: 'z',
    Ż: 'Z',
    ż: 'z',
    Ž: 'Z',
    ž: 'z',
};
const CHAR_PATTERN = new RegExp(Object.keys(CHAR_MAP).join('|'), 'g');
/**
 * Replaces special chars with classical chars from alphabet
 */
export const _replaceSpecialChars = (strWithSpecialChars) => {
    return strWithSpecialChars.replace(CHAR_PATTERN, (match) => {
        return CHAR_MAP[match] ?? match;
    });
};
/**
 * Converts value to string, removes accents and transforms to lower case and applies custom regex rules
 */
export const _normalize = (value, addressKey) => {
    if (isObject(value) || Array.isArray(value)) {
        return null;
    }
    // normalize value
    let normalizedValue = _replaceSpecialChars(String(value).trim())
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/, ' ')
        .replace(/[^a-zA-Z0-9\-\. ']/g, '')
        .toLowerCase();
    const addressKeyRules = RULES[addressKey] ?? [];
    // apply custom rules for address part
    if (addressKey && addressKeyRules.length > 0) {
        for (const { value: val, reg } of addressKeyRules) {
            if (reg.test(normalizedValue)) {
                normalizedValue = normalizedValue.replace(reg, val);
            }
        }
    }
    // remove all whitespaces and dashes
    normalizedValue = normalizedValue.replace(/[\s-]/g, '');
    return normalizedValue;
};
/**
 * Creates object that contains hashes of address parts
 */
export const createAddressObject = (address, digest = true) => {
    if (!isObject(address)) {
        return {};
    }
    const normalizedObject = Object.entries(address).reduce((hashedAddressObj, [key, val]) => {
        if (isValidSHA256String(val)) {
            hashedAddressObj[key] = val;
            return hashedAddressObj;
        }
        // normalize value
        const normalizedAddressPart = _normalize(val, key);
        // hash normalized value when exists
        if (normalizedAddressPart) {
            // street part includes house number
            if (key === AID.street && normalizedAddressPart.includes('|')) {
                const [street, houseNumber] = normalizedAddressPart.split('|');
                if (street) {
                    hashedAddressObj[AID.street] = street;
                }
                // when original houseNumber field is empty, fill it
                if (houseNumber != null && !address[AID.houseNumber]) {
                    hashedAddressObj[AID.houseNumber] = houseNumber;
                }
            }
            else {
                hashedAddressObj[key] = normalizedAddressPart;
            }
        }
        return hashedAddressObj;
    }, {});
    if (digest) {
        const hashedObject = Object.entries(normalizedObject).map(([key, val]) => {
            if (isValidSHA256String(val)) {
                return [key, val];
            }
            else {
                return [key, digestMessage(val)];
            }
        });
        return Object.fromEntries(hashedObject);
    }
    else {
        return normalizedObject;
    }
};
